// kpis
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/tiktok/avgEngagementRateHistory';
import { followerGrowthConfig } from '@/lib/analytics/charts/tiktok/followerGrowthHistory';
import { postDensityConfig } from '@/lib/analytics/charts/tiktok/postDensity';
import { profileViewsConfig } from '@/lib/analytics/kpis/tiktok/profileViews';
import { totalEngagementConfig } from '@/lib/analytics/kpis/tiktok/totalEngagement';
import { videosConfig } from '@/lib/analytics/kpis/tiktok/totalVideos';
import { totalViewsConfig } from '@/lib/analytics/kpis/tiktok/totalViews';


// Charts
import { avgEngagementRatePerVideoConfig } from '@/lib/analytics/kpis/tiktok/avgEngagementRatePerVideo';
import { totalFollowersConfig } from '@/lib/analytics/kpis/tiktok/totalFollowers';

//widget
import { mostRecentVideosConfig } from '@/lib/analytics/widget/tiktok/mostRecentVideosConfig';
import { SIZE_25, SIZE_33 } from '@/lib/gridElements/size';
import { postReachConfig } from '../../kpis/tiktok/postReach';

export const OverviewTiktokBusiness = [
    {...totalFollowersConfig, size: SIZE_25},
    {...videosConfig, size: SIZE_25},
    {...totalViewsConfig, size: SIZE_25},
    {...postReachConfig, size: SIZE_25},

    {...avgEngagementRatePerVideoConfig, size: SIZE_33},
    {...totalEngagementConfig, size: SIZE_33},
    {...profileViewsConfig, size: SIZE_33},

    followerGrowthConfig,
    avgEngagementRateHistoryConfig,

    mostRecentVideosConfig,
];

export const requestTiktokBusinessParams = [
    [
        'videos',
        'views',
        'reach',
        'engagement',
        'average_engagement_rate_per_views',
        'average_engagement_rate_per_video',
    ],
    [
        'followers',
        'followers_growth',
        'profile_views'
    ],
    [
        'average_engagement_rate_history'
    ]
];

export const requestTiktokBusinessOtherParameters = {
    posts_density: {
        type: postDensityConfig.defaultFilter
    }
};
